"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFilterOption = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const mobx_1 = require("mobx");
const quantityHelpers_1 = require("../../helpers/quantityHelpers");
const vocabularies_1 = require("../../vocabularies");
class PriceFilterOption {
    constructor() {
        this.setMin = (price) => {
            this.min = price;
        };
        this.setMax = (price) => {
            this.max = price;
        };
        this.reset = () => {
            this.min = undefined;
            this.max = undefined;
        };
        this.isInRange = (salePrice) => {
            if (salePrice === null)
                return false;
            return (0, quantityHelpers_1.checkRange)(salePrice, this.min, this.max);
        };
    }
    get isSet() {
        return Boolean(this.min || this.max);
    }
    get rangeMessage() {
        if (!this.min && !this.max) {
            return;
        }
        if (this.min && !this.max) {
            return `${(0, homi_shared_1.formatCurrencyFromCents)(this.min)} ~ ${vocabularies_1.FilterVocabulary.UNLIMITED}`;
        }
        if (!this.min && this.max) {
            return `$0 ~ ${(0, homi_shared_1.formatCurrencyFromCents)(this.max)}`;
        }
        return `${(0, homi_shared_1.formatCurrencyFromCents)(this.min || 0)} ~ ${(0, homi_shared_1.formatCurrencyFromCents)(this.max || 0)}`;
    }
}
exports.PriceFilterOption = PriceFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], PriceFilterOption.prototype, "min", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], PriceFilterOption.prototype, "max", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], PriceFilterOption.prototype, "setMin", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], PriceFilterOption.prototype, "setMax", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], PriceFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], PriceFilterOption.prototype, "isSet", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], PriceFilterOption.prototype, "rangeMessage", null);
//# sourceMappingURL=PriceFilterOption.js.map